import PlanActionTypes from './types';

const ALREADY_SETTLED_MESSAGE = 'Payment for this pass is already settled';

const defaultState = {
  planDetails: {},
  isFetching: false,
  hasError: false,
  fetchErrorText: '',
  transactionDetails: {},
  transactionStatusDetails: {},
  statusUpdated: false,
  errorText: '',
  paymentErrorText: '',
  paymentAlreadySettled: false,
};

const consignerPlanReducer = (state: any = defaultState, action: { type: string; payload: any }) => {
  switch (action.type) {
    case PlanActionTypes.FETCH_CONSIGNER_PLAN_DETAILS_START: {
      return { ...state, isFetching: true, hasError: false, fetchErrorText: '', planDetails: {} };
    }

    case PlanActionTypes.FETCH_CONSIGNER_PLAN_DETAILS_SUCCESS: {
      const data = action.payload?.data || {};
      return { ...state, isFetching: false, planDetails: data };
    }

    case PlanActionTypes.FETCH_CONSIGNER_PLAN_DETAILS_FAILURE: {
      const message = action.payload?.response?.data?.message || '';
      if (message === ALREADY_SETTLED_MESSAGE) {
        return { ...state, isFetching: false, hasError: false, paymentAlreadySettled: true };
      }
      return {
        ...state,
        isFetching: false,
        hasError: true,
        fetchErrorText: message,
      };
    }

    case PlanActionTypes.INITIATE_CONSIGNER_PLAN_PAYMENT_START: {
      return { ...state, isFetching: true, paymentErrorText: '' };
    }

    case PlanActionTypes.INITIATE_CONSIGNER_PLAN_PAYMENT_SUCCESS: {
      const data = action.payload?.data || {};
      return { ...state, isFetching: false, transactionDetails: data };
    }

    case PlanActionTypes.INITIATE_CONSIGNER_PLAN_PAYMENT_FAILURE: {
      return {
        ...state,
        isFetching: false,
        paymentErrorText: action.payload?.response?.data?.message || 'Something went wrong',
      };
    }

    case PlanActionTypes.INITIATE_CONSIGNER_PLAN_PAYMENT_STATUS_START: {
      return {
        ...state,
        isFetching: true,
        transactionStatusDetails: {},
        statusUpdated: false,
        errorText: '',
      };
    }

    case PlanActionTypes.INITIATE_CONSIGNER_PLAN_PAYMENT_STATUS_SUCCESS: {
      const data = action.payload?.data || {};
      return {
        ...state,
        isFetching: false,
        statusUpdated: true,
        transactionStatusDetails: data,
      };
    }

    case PlanActionTypes.INITIATE_CONSIGNER_PLAN_PAYMENT_STATUS_FAILURE: {
      return {
        ...state,
        isFetching: false,
        statusUpdated: false,
        transactionStatusDetails: {},
        errorText: action.payload?.response?.data?.message || 'Something went wrong',
      };
    }

    default:
      return state;
  }
};

export default consignerPlanReducer;
